// Shared numbers, dates and sorting for the inventory pages.

export const toNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

// "2.50" -> "2.5", "3.00" -> "3"
export const formatQuantity = (value) => {
  const number = toNumber(value);
  return number === null ? '' : String(Number(number.toFixed(2)));
};

export const formatDate = (value) => {
  if (!value) return '';
  return new Date(value).toLocaleDateString(undefined, { month: 'numeric', day: 'numeric', year: '2-digit' });
};

export const formatDateTime = (value) => {
  if (!value) return '';
  return new Date(value).toLocaleString(undefined, {
    month: 'numeric', day: 'numeric', year: '2-digit', hour: 'numeric', minute: '2-digit',
  });
};

export const daysSince = (value) => {
  if (!value) return null;
  return Math.floor((Date.now() - new Date(value).getTime()) / 86400000);
};

// Bins are usually numbers ("2", "10"), so compare them the way people count.
export const compareText = (a, b) => String(a || '').localeCompare(String(b || ''), undefined, { numeric: true, sensitivity: 'base' });

export const errorMessage = (err, fallback) => {
  const data = err && err.response && err.response.data;
  if (!data || typeof data === 'string') return fallback;
  if (data.detail) return data.detail;
  const first = Object.values(data)[0];
  return first ? [].concat(first).join(' ') : fallback;
};

// How people tell bags apart: the last weight and when it was weighed or came in.
export const bagLabel = (bag) => (bag.last_weighed_at
  ? `weighed ${formatDate(bag.last_weighed_at)}`
  : `received ${formatDate(bag.added_at)}`);
